<script>
  import { animate } from 'animejs'
  import { onMount } from 'svelte'

  import Container from '~/components/ui/container.svelte'

  import AboutBusinessList from './_business-list.svelte'

  onMount(() => {
    animate('.headline-animation .el-animated', {
      rotateX: [90, 0],
      duration: 1 * 1000,
    })
  })
</script>

<section class="section | mb-[128px]">
  <Container>
    <div class="headline-animation min-h-[24vh] lg:h-auto lg:border-l-2 lg:border-gray-300 lg:px-8">
      <h1 class="el-animated mb-6 text-4xl lg:w-1/3 lg:text-7xl">Quem somos</h1>

      <p class="el-animated text-md lg:w-8/12">
        Opa, Tudo bom?. A gente construiu a empresa para turbinar soluções customizadas. Se sua
        empresa é do Brasil você tem muita sorte da gente estar aqui. Nós confiamos e trazemos
        segurança pra nossos semelhantes, Criando aplicações de Bate-Volta. Sim isso mesmo rápidas.
        Sem muita conversa fiada, sem dores de cabeça.
      </p>
    </div>

    <hr class="my-[48px]" />

    <AboutBusinessList />
  </Container>
</section>
